import { takeLatest, put, all, call } from 'redux-saga/effects';

import MonthlyProgressActionTypes from './monthly-progress.types';

import { monthlyProgressListGet } from './monthly-progress.service';

import {
	getMonthlyProgressDetailsSuccess,
	getMonthlyProgressDetailsFailure,
	getMonthlyProgressDetailsResponseChanged,
} from './monthly-progress.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET MONTHLY PROGRESS DETAILS  ******************** */
export function* getMonthlyProgressList({ payload }: any) {
	try {
		const key = 'GetMonthlyReportProgressKey';
		const jsonData = {
			CompanyID: payload.companyID,
			OfficerID: payload.officerID,
			BranchID: payload.branchID,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(monthlyProgressListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMonthlyProgressDetailsFailure(responseData.data));
		} else {
			yield put(getMonthlyProgressDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMonthlyProgressDetailsFailure(error));
	}
}

export function* resetGetMonthlyProgressListResponse() {
	yield put(getMonthlyProgressDetailsResponseChanged());
}

export function* onGetMonthlyProgressListDetails() {
	yield takeLatest(
		MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_START,
		getMonthlyProgressList,
	);
}

export function* onGetMonthlyProgressListResponseReset() {
	yield takeLatest(
		MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_RESPONSE_RESET,
		resetGetMonthlyProgressListResponse,
	);
}
/** *********************  END GET MONTHLY PROGRESS LIST ******************** */

export function* monthlyProgressSaga() {
	yield all([call(onGetMonthlyProgressListDetails), call(onGetMonthlyProgressListResponseReset)]);
}
